"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FilterCheckbox = void 0;
var react_1 = __importDefault(require("react"));
var storm_ui_1 = require("@amzn/storm-ui");
var FilterCheckbox = function (props) {
    var categoryFilters = props.categoryFilters, checkboxLabel = props.checkboxLabel, checkboxValue = props.checkboxValue, id = props.id, setAppliedFilters = props.setAppliedFilters, publishMetrics = props.publishMetrics;
    var checkedOptions = categoryFilters.selected ? categoryFilters.selected : [];
    var isChecked = checkedOptions.some(function (selectedOption) {
        return selectedOption.value === checkboxValue;
    });
    var handleChange = function () {
        var createNewFilter = function (selectedOptions) {
            return __assign(__assign({}, categoryFilters), { selected: selectedOptions });
        };
        if (publishMetrics) {
            publishMetrics(checkboxValue, !isChecked);
        }
        if (!isChecked) {
            var newSelectedOption = { label: checkboxLabel, value: checkboxValue };
            var listPlusChecked = checkedOptions ? __spreadArray(__spreadArray([], checkedOptions, true), [newSelectedOption], false) : [newSelectedOption];
            setAppliedFilters(createNewFilter(listPlusChecked));
        }
        else {
            var listMinusUnchecked = checkedOptions && checkedOptions.filter(function (option) { return option.value !== checkboxValue; });
            setAppliedFilters(createNewFilter(listMinusUnchecked));
        }
    };
    return react_1.default.createElement(storm_ui_1.Checkbox, { id: id, label: checkboxLabel, checked: isChecked, onChange: handleChange });
};
exports.FilterCheckbox = FilterCheckbox;
